export enum LeaveOperations {
    NewLeave = 1,
    NewLeaveWithoutManagement = 2,
    OldLeave = 3,
    Alta = 4,
    ConfirmarDatos = 5,
    AltaNoConfirmada = 6
}
